var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.a,.b{fill:none;}.b{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1178 -473)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19,
    height: 19,
    transform: "translate(1178 473)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1180.375 474.583)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,6H17.25",
    transform: "translate(-3 -2.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.083,5.167V16.25A1.583,1.583,0,0,1,14.5,17.833H6.583A1.583,1.583,0,0,1,5,16.25V5.167m2.375,0V3.583A1.583,1.583,0,0,1,8.958,2h3.167a1.583,1.583,0,0,1,1.583,1.583V5.167",
    transform: "translate(-3.417 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTrashIcon);
export default __webpack_public_path__ + "static/media/white-trash-icon.094a04e2e8b982fb0c6c2a126f7431e7.svg";
export { ForwardRef as ReactComponent };